<template>
  <div class="page-content">
    <h3 class="mb-2 mb-md-0">Candidate Details</h3>
    <div class="my-5">

      <div class="row">
        <!-- <div class="d-flex "> -->
        <!-- added filters to search candidate details -->
        <!-- <div class="col-12 col-sm-6 col-md-4 col-xl-4"> -->
        <!-- <div class="form-group mb-4"> -->
        <div :class="{ disabled: isDisabled, enabled: !isDisabled }"
          :style="{ pointerEvents: isDisabled ? 'none' : 'auto' }">
          <div class="col-12 col-sm-4 col-md-3 col-lg-2 col-xl-2 m-2">
            <label class="input-hero">
              <select class="form-select input_area select_ca" type="text" v-model="FilterQuery"
                @change="ChangePlaceHolder()">
                <option disabled value="" selected>Please select one </option>
                <option v-for="filter in Filters" :key="filter" :value="filter">
                  {{ filter.label }}
                </option>
              </select>
              <!-- <span class="input-name w-auto">Please select one</span> -->
            </label>

          </div>

          <div class="col-12 col-sm-8 col-md-3 col-lg-6 col-xl-6 m-2">
            <div style="width: 100%;">
              <label class="input-hero" style="width: 100%;">


                <label v-if="FilterQuery.key == 4" class="input-hero">
                  <select class="input_area select_ca" type="text" v-model="FilterQueryValue">
                    <option disabled value="" selected>Please select one</option>
                    <option>
                      System
                    </option>
                    <option>
                      Test
                    </option>
                  </select>
                  <span class="input-name">Please select one</span>
                </label>


                <label v-else-if="FilterQuery.key == 11" class="input-hero">
                  <select class="input_area select_ca" type="text" v-model="FilterQueryValue">
                    <option disabled value="" selected>Please select one</option>
                    <option v-for="status in CandidateStatusTypes" :key="status"
                      :value="CandidateStatusTypes.indexOf(status)">
                      {{ status }}
                    </option>
                  </select>
                  <span class="input-name">Please select one</span>
                </label>


                <input v-else :type="inputType" style="width: 100%;" class="form-control" id="candidateValue"
                  v-model="FilterQueryValue" :placeholder="DynamicPlaceHolder"
                  @keyup.enter="addFilter(FilterQuery, FilterQueryValue)" @keydown="preventSpace"
                  @input="validateInput(FilterQuery, $event)" />

              </label>
            </div>


          </div>

          <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 m-2 d-flex">
            <div class="col-12 col-lg-1 col-md-12 ms-3 d-inline-block w-auto">
              <button class=" btn " type="button" @click="addFilter(FilterQuery, FilterQueryValue)">
                <i class="bi bi-plus-lg p-2" style="color:gray;"></i>
                <span style="size:10px;color: gray;">Add Filter</span>
              </button>
            </div>
            <!-- </div>

          <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 m-2"> -->
            <div class="col-12 col-lg-1 col-md-12 mx-3 w-auto" v-if="this.filterapplied != false">
              <button class=" test_instance_button btn btn-primary" type="button"
                @click="applyFilter(this.queryString)">
                <i class=" mx-1 fa-solid fa-magnifying-glass " style="color: #ffffff;"></i>
                Show Result
              </button>
            </div>
          </div>
        </div>




        <!-- </div> -->
        <!-- </div> -->







        <!-- </div> -->


        <!-- index slice -->
        <!-- document.getElementByClass("table-responsive").style.visibility="hidden" -->
        <!-- <div>{{ queryString }}</div> -->

        <!-- table to display the choosen filters -->
        <div class="card p-2 my-3 mx-3  " style="width:97%;" v-if="this.filterapplied != false">
          <div class="table-responsive" style="min-height: 0;">
            <table class="table h-auto ">
              <thead>
                <tr>
                  <th>Filter Type</th>
                  <th>Filter Value</th>
                  <th>Remove</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody style="width: 80%; height: 100%; max-height: 200px;">
                <tr v-for="(item, index) in queryString" :key="item">
                  <td>{{ this.searchFilters[item.key - 1].label }}</td>
                  <td :key="index">
                    <span v-if="editableItemId != index">
                      <span v-if="item.key == 11">
                        {{ CandidateStatusTypes[item.label] }}
                      </span>
                      <span v-else-if="item.key == 9 || item.key == 10">
                        {{ dateConvert(item.label) }}
                      </span>
                      <span v-else>{{ item.label }}</span>

                    </span>
                    <div v-else>

                      <label v-if="item.key == 4" class="input-hero me-3">
                        <select class=" input_area select_ca " type="text" v-model="item.label">
                          <option disabled value="" selected>Please select one</option>
                          <option>
                            System
                          </option>
                          <option>
                            Test
                          </option>
                        </select>
                        <span class="input-name w-auto">Please select one</span>
                      </label>

                      <label v-else-if="item.key == 11" class="input-hero">
                        <select class="input_area select_ca" type="text" v-model="item.label">
                          <option disabled value="" selected>Please select one</option>
                          <option v-for="status in CandidateStatusTypes" :key="status"
                            :value="CandidateStatusTypes.indexOf(status)">
                            {{ status }}
                          </option>
                        </select>
                        <span class="input-name">Please select one</span>
                      </label>

                      <input v-else :type="inputType" style="width: 100%;" class="form-control"
                        id="candidateEditedValue" v-model="item.label" :placeholder="dynamicPlaceholder"
                        @keydown="preventSpace" @input="validateInput(item, $event)" />
                    </div>

                  </td>
                  <td><i class="bi bi-trash3 "
                      :style="{ pointerEvents: editableItemId == index ? 'none' : 'auto', color: editableItemId == index ? 'gray' : 'black', cursor: editableItemId == index ? 'none' : 'pointer' }"
                      @click="removeFilter(item.key)"></i></td>
                  <td>
                    <i v-if="editableItemId != index" class="bi bi-pencil" style="cursor: pointer;"
                      @click="editItem(item, index)"></i>
                    <i v-else class="bi bi-check-square" style="cursor: pointer;"
                      @click="updateFilter(item, item.label)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr v-if="CandidateDetailsStatus">
        <!-- <div>{{ queryString }}</div> -->

        <!-- <div class="col-12 col-lg-4 col-md-12"> -->

        <!-- <label class="input-hero"> -->
        <!-- <input type="text" class="form-control" id="candidateValue" v-model="searchCandidateData"
                placeholder=" Enter Candidates Name, Email, or Mobile Number" @keyup.enter="GetData()"
                @keydown="preventSpace" /> -->
        <!-- </label> -->
        <!-- </div> -->
        <!-- <div class="col-12 col-lg-1 col-md-12"> -->
        <!-- <button class=" test_instance_button btn btn-primary" type="button" @click="GetData()"> -->
        <!-- <i class=" mx-1 fa-solid fa-magnifying-glass " style="color: #ffffff;"></i> -->
        <!-- Find -->
        <!-- </button> -->
        <!-- </div> -->
      </div>
      <h5 v-if="CandidateDetailsStatus" class="mb-2 mb-md-0" style="color: grey;">Filtered Data</h5>
      <div v-for="item in CandidateDetails" :key="item.candidateId">

        <div class="accordion-item border-radius-kj">
          <h2 class="accordion-header" :id="'heading' + item.candidateId">
            <button class="accordion-button text-dark accordion-color-kj" type="button" data-bs-toggle="collapse"
              :data-bs-target="'#collapse' + item.candidateId" aria-expanded="true"
              :aria-controls="'collapse' + item.candidateId">
              <div class="container">
                <div class="row">
                  <h4>
                    <span @click="copyToClipboard(item.firstName)">{{ item.firstName }}</span><span
                      @click="copyToClipboard(item.lastName)" class="mx-2">{{ item.lastName }}</span>

                    <!-- <img src="../../public/dashboard-assets/images/M2/Actions.png" alt="" /> -->
                  </h4>
                </div>
                <div class="accordion-button-p-kj">

                  <div class="row my-2">
                    <div class="col-12 col-md-4 col-lg-3 col-sm-12" @click="copyToClipboard(item.candidateUniqueId)">
                      Candidate
                      Unique Id: {{ item.candidateUniqueId }}
                    </div>

                    <div class=" col-12 col-md-4 col-lg-3 col-sm-12">
                      <span @click="copyToClipboard(item.testId)">Test Id: {{ item.testId }}</span>
                    </div>
                    <div class="col-12 col-md-4 col-lg-3 col-sm-12">
                      <span @click="copyToClipboard(item.client_Id)">Partner Id: {{ item.client_Id }}</span>
                    </div>
                    <div class="col-12 col-md-4 col-lg-3 col-sm-12" v-if="this.superadmin()">
                      <span @click="copyToClipboard(item.candidateId)">Candidate Id: {{ item.candidateId }}</span>
                    </div>
                  </div>
                </div>

              </div>

            </button>
          </h2>
          <div :id="'collapse' + item.candidateId" class="accordion-collapse collapse"
            :aria-labelledby="'heading' + item.candidateId">
            <div class="accordion-body p-0 managementPartner-Acc-p-kj">
              <div class="container">
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-3 col-sm-12">
                    <div class="p-3 " @click="copyToClipboard(item.emailAddress)">
                      <h5><b>Email Address:</b></h5>
                      {{ item.emailAddress }}
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 col-sm-12">
                    <div class="p-3 " @click="copyToClipboard(item.inviteFrom)">
                      <h5><b>Invite From:</b></h5>
                      {{ item.inviteFrom }}
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 col-sm-12">
                    <div class="p-3 " @click="copyToClipboard(item.examStartTime)">
                      <h5><b>Exam Start Time: </b></h5>
                      {{ dateConvert(item.examStartTime) }}
                    </div>
                  </div>

                  <div class="col-12 col-md-6 col-lg-3 col-sm-12">
                    <!-- <div class="p-3 ">
                      <h5><b>Status:</b></h5>
                      <span v-if="item.isCompleted == true">
                        <i class="fa-solid fa-square-check fa-lg" style="color: #048848;"></i>
                      </span>
                      <span v-else>
                        <i class="fa-solid fa-square-xmark fa-lg" style="color: #e11900;"></i>
                      </span>
                    </div> -->
                    <div class="p-3">
                      <h5><b>Result:</b></h5>


                      <div style="margin-left: -1%; margin-top: 1%;">
                        <SwitchCase :expected="item.candidateStatus" :result="0">
                          <template v-slot="{ current }">
                            <span class="View-Candidates-clock" v-if="current">Pending <i
                                class="fa-solid fa-clock-rotate-left"></i></span>
                          </template>
                        </SwitchCase>
                        <SwitchCase :expected="item.candidateStatus" :result="1">
                          <template v-slot="{ current }">
                            <span class="View-Candidates-progress" v-if="current">InProgress <i
                                class="fa-solid fa-stopwatch me-2"></i></span>
                          </template>
                        </SwitchCase>
                        <SwitchCase :expected="item.candidateStatus" :result="2">
                          <template v-slot="{ current }">
                            <span class="View-Candidates-review" v-if="current">Review <i
                                class="fa-regular fa-clock me-2"></i></span>
                          </template>
                        </SwitchCase>
                        <SwitchCase :expected="item.candidateStatus" :result="3">
                          <template v-slot="{ current }">
                            <span class="View-Candidates-pass" v-if="current">Pass <i
                                class="fa-solid fa-check me-2"></i></span>
                          </template>
                        </SwitchCase>
                        <SwitchCase :expected="item.candidateStatus" :result="4">
                          <template v-slot="{ current }">
                            <span class="View-Candidates-xmark" v-if="current">Fail <i
                                class="fa-solid fa-xmark me-2"></i></span>
                          </template>
                        </SwitchCase>
                      </div>


                    </div>

                  </div>

                </div>
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-3 col-sm-12">
                    <div class="p-3" @click="copyToClipboard(item.mobileNo)">
                      <h5><b>Mobile No.</b></h5> {{ item.mobileNo }}
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 col-sm-12">
                    <div class="p-3" @click="copyToClipboard(item.createdOn)">
                      <h5><b>Created On: </b></h5>{{ dateConvert(item.createdOn) }}
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 col-sm-12">
                    <div class="p-3" @click="copyToClipboard(item.examEndTime)">
                      <h5><b>Exam End Time:</b></h5>{{ dateConvert(item.examEndTime) }}
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-3 col-sm-12">
                    <div>
                      <router-link :to="{
                        name: 'ActiveTestViewCandidatesNew',
                        params: {
                          testId: encode(item.testId),
                          clientId: encode(item.client_Id),
                          isParent: encode(1), //update
                        },
                        query: {
                          search: encode(item.testId),
                          offset: encode(1),
                          current: encode(1),
                          email: encode(item.emailAddress)
                        },
                      }" target="_blank">
                        <button class="mx-2 my-3 test_instance_button btn btn-primary" type="button">
                          View
                        </button>
                      </router-link>
                      <button class="mx-2 my-3 test_instance_button btn btn-primary" type="button"
                        @click="UpdateData(item.candidateId)"
                        v-if="this.superadmin() && (item.candidateStatus == 3 || item.candidateStatus == 2 || item.candidateStatus == 4)">
                        Update Result
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div class="text-center" v-if="!CandidateDetailsStatus">
      <img src="../../public/dashboard-assets/images/M2/empty_record.png" style="width: 20%" class="my-5" />
      <h3 class="ms-5 mt-2 h3">No Candidate Details Found</h3>
    </div>

    <paginate v-model="currentPage" :page-count="Page_count" :margin-pages="1" :page-range="1"
      :click-handler="clickCallback" :prev-text="'< Prev'" :next-text="'Next >'" :container-class="'pagination'"
      :page-class="'page-item'" v-if="CandidateDetailsStatus"></paginate>
  </div>
</template>

<script>
import { superadmin } from "../utils/helper";
import Paginate from "vuejs-paginate-next";
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
import SwitchCase from './SwitchCase.vue';
import { SetClarityData } from "../platformFeatures/featureUtils";

export default {
  name: "CandidateDetails",
  components: {
    paginate: Paginate,
    SwitchCase
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      clientId: (state) => state.auth.user.clientId,
    }),
  },

  data() {
    return {
      searchCandidateData: "",
      ClientId: null,
      TestId: null,
      CandidateId: null,
      CandidateIdType: "",
      FirstName: "",
      LastName: "",
      EmailId: "",
      PhoneNo: "",
      FromDate: "",
      ToDate: "",
      CandidateStatus: null,
      CandidateStatusTypes: [
        "Pending",
        "InProgress",
        "Review",
        "Pass",
        "Fail",
      ],
      searchFilters: [
        { key: 1, label: "ClientId" },
        { key: 2, label: "TestId" },
        { key: 3, label: "CandidateId" },
        { key: 4, label: "CandidateIdType" },
        { key: 5, label: "FirstName" },
        { key: 6, label: "LastName" },
        { key: 7, label: "EmailId" },
        { key: 8, label: "PhoneNo" },
        { key: 9, label: "StartDate" },
        { key: 10, label: "EndDate" },
        { key: 11, label: "CandidateStatus" }
      ],
      Filters: [
        { key: 1, label: "ClientId" },
        { key: 2, label: "TestId" },
        { key: 3, label: "CandidateId" },
        { key: 4, label: "CandidateIdType" },
        { key: 5, label: "FirstName" },
        { key: 6, label: "LastName" },
        { key: 7, label: "EmailId" },
        { key: 8, label: "PhoneNo" },
        { key: 9, label: "StartDate" },
        { key: 10, label: "EndDate" },
        { key: 11, label: "CandidateStatus" }
      ],
      DynamicPlaceHolder: "Select Filter",
      inputType: "text",
      CandidateDetails: [],
      CandidateDetailsStatus: false,
      Page_count: 1,
      Offset: 1,
      Limit: 10,
      currentPage: 1,
      filterCount: 1,
      queryString: [],
      FilterQuery: "",
      type: '',
      filterapplied: false,
      isDisabled: false,
      editableItemId: null,
    };
  },
  mounted() {
    SetClarityData();
  },
  methods: {
    ...mapActions(["GetCandidateDetails", "GetCandidateDetailsV2", "updateCandidateDetails", "ShowSucessMessage", "ShowErrorMessage", "ShowWarningMessage"]),

    ...mapMutations(["setLoading"]),
    superadmin,
    dateConvert(value) {
      if (value != null) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
      else {
        return "null";
      }
    },
    encode: function (item) {
      return window.btoa(item);
    },
    async UpdateData(id) {
      await this.updateCandidateDetails({
        candidateId: id
      });
    },
    //adds filter into the query string
    async addFilter(key, value) {
      if (value == null || this.FilterQueryValue === '') {
        return this.ShowErrorMessage("Please Enter a valid entry")
      }
      if (key.length == 0) {
        return this.ShowErrorMessage("Please select a filter")
      }
      if (key.key == 7) {
        const regex = /[a-zA-Z0-9_\-.]+[@][a-z]+[.][a-z]{2,3}/;
        if (regex && !regex.test(value)) {
          key = "";
          return this.ShowErrorMessage("Please Enter a valid entry")

        }
      }
      if (key.key == 10) {
        var data = this.queryString.find(obj => obj.key === 9);
        if (data == null) {
          return this.ShowWarningMessage("Please Enter Start Date First")
        }
        else {
          if (value < data.label || value == data.label) {
            return this.ShowErrorMessage("End date should be greater than the start date")
          }
        }
      }
      this.queryString.push({ key: key.key, label: value });
      this.Filters = this.Filters.filter(item => item.key != key.key);
      this.DynamicPlaceHolder = "Select Filter";
      this.FilterQueryValue = '';
      this.FilterQuery = "";
      if (this.queryString.length != 0) {
        this.filterapplied = true;
      }
    },
    updateFilter(key, value) {
      if (key.key == 7) {
        const regex = /[a-zA-Z0-9_\-.]+[@][a-z]+[.][a-z]{2,3}/;
        if (regex && !regex.test(value)) {
          key = "";
          return this.ShowErrorMessage("Please Enter a valid entry")

        }
      }

      if (key.key == 10) {
        var data = this.queryString.find(obj => obj.key === 9);
        if (data == null) {
          return this.ShowWarningMessage("Please Enter Start Date First")
        }
        else {
          if (value < data.label || value == data.label) {
            return this.ShowErrorMessage("End date should be greater than the start date")
          }
        }
      }
      else if (key.key == 9 && this.queryString.find(obj => obj.key === 10) != null) {
        if (value > this.queryString.find(obj => obj.key === 10).label || value == this.queryString.find(obj => obj.key === 10).label) {
          return this.ShowErrorMessage("Start date should be less that the end date")
        }
      }
      this.queryString = this.queryString.filter(item => item.key != key.key);
      this.queryString.push({ key: key.key, label: value });
      this.Filters = this.Filters.filter(item => item.key != key.key);
      this.FilterQueryValue = '';
      if (this.queryString.length != 0) {
        this.filterapplied = true;
      }
      this.editableItemId = null;
      this.isDisabled = false;
    },
    //change placeholder
    async ChangePlaceHolder() {
      this.FilterQueryValue = '';
      this.$nextTick(() => {
        this.FilterQueryValue = '';
        this.DynamicPlaceHolder = 'Enter ' + this.FilterQuery.label;
        if (this.FilterQuery.key == 1 || this.FilterQuery.key == 2 || this.FilterQuery.key == 3 || this.FilterQuery.key == 11 || this.FilterQuery.key == 8) {
          this.inputType = "number";
        }
        else if (this.FilterQuery.key == 9 || this.FilterQuery.key == 10) {
          this.inputType = "date";
        }
        else {
          this.inputType = "text";
        }
      });
    },

    validateInput(item, event) {
      const value = event.target.value;
      if (item.key == 1 || item.key == 2 || item.key == 3 || item.key == 11 || item.key == 8) {
        event.target.value = value.replace(/\D/g, '');
        item = event.target.value;
      }
      else if (item.key == 5 || item.key == 6) {
        event.target.value = value.replace(/[^a-zA-Z]/g, '');
        item = event.target.value;
      }
      else {
        item = event.target.value;
      }
    },

    //remove filters from the query string
    async removeFilter(key) {
      this.queryString = this.queryString.filter(item => item.key != key);

      if (this.queryString.length == 0) {
        this.filterapplied = false;

      }
      this.isDisabled = false;
      this.editableItemId = null;
      this.Filters.push({ key: key, label: this.searchFilters[key - 1].label });


    },
    editItem(item, index) {
      this.isDisabled = true;
      this.FilterQuery = [{ key: item.key, label: this.searchFilters[item.key - 1].label }];
      this.FilterQuery.key = item.key;
      this.FilterQuery.label = this.searchFilters[item.key - 1].label;
      this.ChangePlaceHolder();
      this.editableItemId = index;
    },

    resetData() {
      this.ClientId = "";
      this.TestId = "";
      this.CandidateId = "";
      this.CandidateIdType = "";
      this.FirstName = "";
      this.LastName = "";
      this.EmailId = "";
      this.PhoneNo = "";
      this.FromDate = "";
      this.ToDate = "";
      this.CandidateStatus = "";
    },

    async applyFilter(data) {
      this.resetData();
      data.forEach(element => {
        if (element.key == 1) {
          this.ClientId = element.label;
        }
        if (element.key == 2) {
          this.TestId = element.label;
        }
        if (element.key == 3) {
          this.CandidateId = element.label;
        }
        if (element.key == 4) {
          this.CandidateIdType = element.label;
        }
        if (element.key == 5) {
          this.FirstName = element.label;
        }
        if (element.key == 6) {
          this.LastName = element.label;
        }
        if (element.key == 7) {
          this.EmailId = element.label;
        }
        if (element.key == 8) {
          this.PhoneNo = element.label;
        }
        if (element.key == 9) {
          this.FromDate = element.label;
        }
        if (element.key == 10) {
          this.ToDate = element.label;
        }
        if (element.key == 11) {
          this.CandidateStatus = element.label;
        }
      });
      this.GetData();
    },



    async copyToClipboard(data) {
      await navigator.clipboard.writeText(data);
      return this.ShowSucessMessage(data + " copied");
    },
    // async GetData(pageNum) {
    //   this.CandidateDetails = [];
    //   var value = await this.GetCandidateDetails({
    //     search: this.searchCandidateData === '' ? this.searchCandidateData : encodeURIComponent(this.searchCandidateData),
    //     offset: this.Offset,
    //     limit: this.Limit,
    //   });

    //   if (value.object.data.candidateDetails !== null) {
    //     this.CandidateDetails = value.object.data.candidateDetails;
    //   }

    //   this.Page_count = value
    //     ? Math.ceil(value.object.data.filterCount / this.Limit)
    //     : 0;
    //   this.currentPage = pageNum;
    // },

    //api call according the filters added
    async GetData(pageNum) {
      this.CandidateDetails = [];
      var value = await this.GetCandidateDetailsV2({
        ClientId: this.ClientId != null ? this.ClientId : null,
        TestId: this.TestId != null ? this.TestId : null,
        CandidateId: this.CandidateId != null ? this.CandidateId : null,
        CandidateIdType: this.CandidateIdType === '' ? this.CandidateIdType : encodeURIComponent(this.CandidateIdType),
        FirstName: this.FirstName === '' ? this.FirstName : encodeURIComponent(this.FirstName),
        LastName: this.LastName === '' ? this.LastName : encodeURIComponent(this.LastName),
        EmailId: this.EmailId === '' ? this.EmailId : encodeURIComponent(this.EmailId),
        PhoneNo: this.PhoneNo === '' ? this.PhoneNo : encodeURIComponent(this.PhoneNo),
        FromDate: this.FromDate === '' ? this.FromDate : encodeURIComponent(this.FromDate),
        ToDate: this.ToDate === '' ? this.ToDate : encodeURIComponent(this.ToDate),
        CandidateStatus: this.CandidateStatus === null ? null : this.CandidateStatus,

        offset: this.Offset,
        limit: this.Limit,
      });


      if (value.status) {
        this.CandidateDetails = value.object.data.candidateDetails;
        this.CandidateDetailsStatus = true;
      }
      else {
        this.CandidateDetailsStatus = false;
      }

      this.Page_count = value
        ? Math.ceil(value.object.data.filterCount / this.Limit)
        : 0;
      this.currentPage = pageNum;
    },
    // To be implemented later
    // async candidateStatusDetails(status){

    //   switch(status){
    //     case 0:
    //     return (
    //         <span class="View-Candidates-clock">
    //           Pending <i class="fa-solid fa-clock-rotate-left"></i>
    //         </span>
    //       );

    //     case 1:
    //     return (
    //         <span class="View-Candidates-progress">
    //           InProgress <i class="fa-solid fa-stopwatch me-2"></i>
    //         </span>
    //       );

    //       case 2:
    //       return (
    //         <span class="View-Candidates-review">
    //           Review <i class="fa-regular fa-clock me-2"></i>
    //         </span>
    //       );
    //         var1 = "View-Candidates-review";
    //         var2 = "fa-regular fa-clock me-2";
    //     case 3:
    //       return (
    //         <span class="View-Candidates-pass">
    //           Pass <i class="fa-solid fa-check me-2"></i>
    //         </span>
    //       );
    //     case 4:
    //       return (
    //         <span class="View-Candidates-xmark">
    //           Failed <i class="fa-solid fa-xmark me-2"></i>
    //         </span>
    //       );
    //     default:
    //       return null; 

    //   }

    // },

    clickCallback: function (pageNum) {
      this.Offset = (pageNum - 1) * this.Limit + 1;
      this.GetData(pageNum);
    },
    preventSpace(event) {
      const input = event.target.value;
      if (event.key === ' ' && input.length === 0) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
.pagination {
  justify-content: flex-end;
}

.pagination .page-item.active .page-link {
  font-weight: 600;
  background: #ffc801;
}

.pagination .page-item:last-child .page-link {
  background-color: transparent;
  border: none;
  width: 100% !important;
}

.pagination .page-item:first-child .page-link {
  background-color: transparent;
  border: none;
  width: 100% !important;
}

.pagination .page-item.disabled .page-link {
  color: rgb(130, 130, 130) !important;
  cursor: no-drop !important;
}

.text-label {
  font-size: 100px;
}

/* table css*/
.table-responsive thead th {
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 2;
  /* box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); */
}

.table-title {
  font-size: 18px;
  font-weight: bold;
}

.disabled {
  opacity: 0.5;
  background-color: #f2f2f2;
  display: flex;
}

.enabled {
  display: flex;

}

@media (max-width: 768px) {
  .enabled {
    display: inline;
  }

  .disabled {
    opacity: 0.5;
    background-color: #f2f2f2;
    display: inline;
  }

  .h3{
    font-size: 1rem;
    margin: 0px;
  }

}

</style>